import actions from './actions';
import mutations from './mutations';

const USERROLE_KEY = 'id_userRole';

const md = require('markdown-it')({
    html: true
});

const state = {
    context: {},
    keys: [],
};

const getters = {
    items: state => state.keys.map((key) => {
        return state.context[key];
    }),
    values: (state) => {
        const obj = {};
        const userRole = parseInt(localStorage.getItem(USERROLE_KEY), 10);
        state.keys.forEach((key) => {
            const item = state.context[key];
            const itemKey = item.key.toLowerCase();
            const isGroupLocked = !!item.ownerId;
            let itemValue = null;

            if (item.tags &&
                item.tags.find(e => e.trim().toLowerCase() === 'variable')) {
                // Process variables as booleans, "no" === false, "false" === false
                const falsyStrings = ['false', 'no', ''];
                if (item.value) {
                    const lct = item.value.trim().toLowerCase();
                    itemValue = falsyStrings.find(e => e === lct) ?
                        null : item.value;
                } else {
                    itemValue = null;
                }
                obj[itemKey] = itemValue;
                return;
            } else if (item.value) {
                // Convert to HTML
                const html = md.render(item.value);

                // Remove the encasing <p></p> tags returned from markdown-it
                if (html.startsWith('<p>')) {
                    const isEndWithP = html.trim().endsWith(`</p>`);

                    // obj[itemKey] = html.substring(3, html.length - 5);
                    if (userRole === 4 || userRole === 3 || userRole === 2) {
                        itemValue = `<span class="validContext" style="cursor:pointer;display:inline;" onclick="event.preventDefault(); editItem('${itemKey}')">${html}</span>`;
                    } else {
                        itemValue = html;
                    }

                    itemValue = itemValue.replace(/<p>(.*?)<\/p>/g, '$1<br/><br/>');

                    // remove last <br>
                    if (isEndWithP) {
                        itemValue = itemValue.replace(/\n/g, '').replace(/(.*)<br\/><br\/>/, '$1');
                    }
                } else if (userRole === 4 || userRole === 3 || userRole === 2) {
                    // obj[itemKey] = html;
                    itemValue = `<span class="validContext" style="cursor:pointer;display:inline;" onclick="event.preventDefault(); editItem('${itemKey}')">${html}</span>`;
                } else {
                    itemValue = html;
                }
            } else if (item.placeholder) {
                const phtml = item.placeholder;
                if (userRole === 1) {
                    itemValue = `<span>${phtml}</span>`;
                } else {
                    itemValue = `<span class="placeholder" style="cursor:pointer;" onclick="event.preventDefault(); editItem('${itemKey}')">${phtml}</span>`;
                }
            } else if (userRole === 1) {
                itemValue = `<span>Missing value for context key ${itemKey}</span>`;
            } else {
                itemValue = `<span class="placeholder" style="cursor:pointer;" onclick="event.preventDefault(); editItem('${itemKey}')">Missing value for context key ${itemKey}</span>`;
            }

            // if the key is group locked, add tooltip
            if (isGroupLocked) {
                if (itemValue && itemValue.indexOf('<span') > -1) {
                    itemValue = itemValue.replace('<span', `<span title="This value is managed by your group administrator"`);
                } else {
                    itemValue = `<span title='This value is managed by your group administrator'>${itemValue}</span>`;
                }
            }

            obj[itemKey] = itemValue;
        });
        return obj;
    },

    getContextItem: state => key => state.context[key]
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/clientContext/store.js